export class OmnialContent {
  index: number;
  type: string;
  html: string;
  entityId: number;
  entityName: string;
}
